import { INELIGIBLE_REASON } from '../const/paymentEnterpriseEligibility';
import { t } from '../strings/i18n';
import { checkIneligibilityForAutopayModifyAndCancel, getAutopayModifyUnenrollIneligibility, getAutopayModifyUnenrollIneligibilityReason } from './autopayHelpers';
import { getAutopayEligibilityDetail, isAutopayModifyEligible } from './parseEligibility';
import { isPayLaterProduct, isPN4 } from './productTypeHelpers';
// eslint-disable-next-line max-lines-per-function
export const getManageAutopayMessage = ({ paymentEnterpriseEligibility, nextDueDate, helpNumber, productType }) => {
    const isAutopayUnEnrollEligible = isPayLaterProduct(productType) &&
        getAutopayEligibilityDetail(paymentEnterpriseEligibility, 'AUTOPAY_UNENROLL').eligible;
    const isAutopayModifyIneligible = !isAutopayModifyEligible(paymentEnterpriseEligibility);
    /**
     * Restricting the logic to Pay Later Products
     * because other products does not have the AUTOPAY_UNENROLL support yet
     */
    const displayUnEnrollIneligibilityMessage = isPayLaterProduct(productType) &&
        !isAutopayUnEnrollEligible &&
        !isAutopayModifyIneligible;
    // Checking the InEneligibility reason 👇
    const [isModifyIneligiblePriorToFirstStatement, isUnEnrollIneligibleBeforeFirstStatement] = checkIneligibilityForAutopayModifyAndCancel(paymentEnterpriseEligibility, INELIGIBLE_REASON.statementNotGenerated, productType);
    const [isModifyIneligibleWithin48HourWindow] = checkIneligibilityForAutopayModifyAndCancel(paymentEnterpriseEligibility, INELIGIBLE_REASON.within48HourWindow, productType);
    const [isModifyIneligibleForChannelOrProduct, isUnEnrollIneligibleForChannelOrProduct] = checkIneligibilityForAutopayModifyAndCancel(paymentEnterpriseEligibility, INELIGIBLE_REASON.notEnabledForChannelOrProduct, productType);
    const isModifyUnEnrollIneligiblePriorToFirstStatement = getAutopayModifyUnenrollIneligibilityReason(productType, isModifyIneligiblePriorToFirstStatement, isUnEnrollIneligibleBeforeFirstStatement);
    const isModifyUnEnrollIneligibleForChannelOrProduct = getAutopayModifyUnenrollIneligibilityReason(productType, isModifyIneligibleForChannelOrProduct, isUnEnrollIneligibleForChannelOrProduct);
    const isAutopayModifyAndUnenrollIneligible = getAutopayModifyUnenrollIneligibility(productType, isAutopayModifyIneligible, isAutopayUnEnrollEligible);
    if (isAutopayModifyAndUnenrollIneligible) {
        const isPN4Product = isPN4(productType);
        if (isModifyUnEnrollIneligiblePriorToFirstStatement ||
            (isPN4Product && isModifyIneligiblePriorToFirstStatement)) {
            return t('autopayCollapseBanner.autopayEditPriorFirstStatement');
        }
        if (isModifyUnEnrollIneligibleForChannelOrProduct ||
            (isPN4Product && isModifyIneligibleForChannelOrProduct)) {
            return t('autopayCollapseBanner.autopayEditNotEnabledForChannelOrProduct', {
                helpNumber
            });
        }
        return t('autopayCollapseBanner.autopayModifyInEligibleUnhandledReason');
    }
    if (isModifyIneligibleWithin48HourWindow) {
        return t('autopayCollapseBanner.modifyNotEligibleWithin48HourWindow');
    }
    if (displayUnEnrollIneligibilityMessage) {
        return t('autopayCollapseBanner.autopayUnEnrollIneligibilityMessage');
    }
    if (!nextDueDate) {
        return t('autopay.noNextDueDate');
    }
    return null;
};
